import React, { useState, useEffect } from "react";
import {
    MenuItem,
    Checkbox,
    FormControlLabel,
    withStyles,
} from "@material-ui/core";

const BlueCheckbox = withStyles({
    root: {
        color: "#005CC8",
        "&$checked": {
            color: "#005CC8",
        },
    },
    checked: {},
})(Checkbox);

const withMetadataGridMultiSelectCheckbox = (WrappedComponent) => (props) => {
    const [selectedValues, setSelectedValues] = useState(
        props.value || { appliesToAll: false, elements: [] },
    );
    const [anchorEl, setAnchorEl] = useState(null);

    useEffect(() => {
        const colId = props.column.colId;
        props.node.setDataValue(colId, selectedValues);
    }, [selectedValues, props.column.colId, props.node]);

    const toggleCheckbox = (opt) => {
        if (opt.id === "all") {
            setSelectedValues({
                appliesToAll: !selectedValues.appliesToAll,
                elements: [],
            });
            return;
        }
        const isOptSelected = selectedValues.elements?.some(
            (selected) => selected._id === opt._id,
        );
        const newValues = {
            appliesToAll: false,
            elements: isOptSelected
                ? selectedValues.elements.filter(
                      (selected) => selected._id !== opt._id,
                  )
                : [...selectedValues.elements, opt],
        };

        if (newValues.elements.length === 0) {
            alert("At least one element must be selected!");
            return;
        }

        setSelectedValues(newValues);
    };

    const renderAllOption = () => (
        <MenuItem key={"all"} onClick={(e) => e.stopPropagation()}>
            <FormControlLabel
                control={
                    <BlueCheckbox
                        checked={selectedValues?.appliesToAll}
                        onChange={() => toggleCheckbox({ id: "all" })}
                    />
                }
                label={"All"}
            />
        </MenuItem>
    );

    const handleClose = () => {
        const colId = props?.column?.colId;
        const rowNode = props.api.getRowNode(props.node.id);
        if (rowNode) {
            const updatedData = {...rowNode.data, [colId]: selectedValues};
            rowNode.setData({...rowNode.data, [colId]: selectedValues});
        }
        props.api.stopEditing(true);
    };

    useEffect(() => {
        setAnchorEl(props.eGridCell);
    }, [props.eGridCell]);

    const isOptionChecked = (option) =>
        !selectedValues?.appliesToAll &&
        selectedValues?.elements?.some(
            (selected) => selected._id === option._id,
        );

    const injectedProps = {
        toggleCheckbox,
        anchorEl,
        handleClose,
        renderAllOption,
        isOptionChecked,
    };

    return <WrappedComponent {...props} {...injectedProps} />;
};

export default withMetadataGridMultiSelectCheckbox;
